export default "__VITE_ASSET__BehfM_Fk__"